import { render, staticRenderFns } from "./SectionContextMenu.vue?vue&type=template&id=7c64b566&scoped=true&"
import script from "./SectionContextMenu.vue?vue&type=script&lang=js&"
export * from "./SectionContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./SectionContextMenu.vue?vue&type=style&index=0&id=7c64b566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64b566",
  null
  
)

export default component.exports